<template>
  <v-stepper class="elevation-0">
    <v-stepper-header>
      <fragment
        v-for="(pageName, pageUID, pIndex) in pages.questionnaire"
        :key="pIndex"
      >
        <v-divider v-if="pIndex" />
        <v-stepper-step
          class="text-capitalize tapable"
          :editable="pageID === pIndex"
          :color="pageID === pIndex ||
            (qSections && qSections[$lodash.camelCase(pageUID)])
            ? 'primary' : 'warning'"
          :step="pIndex"
          complete
          :complete-icon="(qSections && qSections[$lodash.camelCase(pageUID)])
            ? 'mdi-check' : 'mdi-dots-horizontal'"
          @click="$utils.navigate(`/questionnaire/${pageUID}`)"
        >
          {{ $t(pageName) }}
        </v-stepper-step>
      </fragment>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
import { computed } from '@vue/composition-api'
import { pages } from '@/constants'
import { useProfile } from '@/use/profile'

export default {
  props: {
    page: {
      type: String,
      default: pages.questionnaire[0]
    }
  },
  setup: (props) => {
    const { qSections } = useProfile()
    const pageID = computed(() => Object.keys(pages.questionnaire)
      .indexOf(props.page))

    return {
      pages,
      pageID,
      qSections
    }
  }
}
</script>
